export const routeColor = "#eb1d2f";
export const ferryColor = "#3284DE";
export const animatedRouteColor = (opacity: number) =>
  `rgba(235, 29, 47, ${opacity})`;
export const fontFamily = "Stena Sans";
